import { ApiSchemas } from '..'
import { client } from '../client'
import { wrapEndpoint } from '../wrap'

export type Physician = ApiSchemas['PhysicianPresenter']

export type BirdIdToken = ApiSchemas['BirdIdTokenPresenter']

export type Crm = ApiSchemas['CrmPresenter']

export default {
  async get(id: number) {
    return wrapEndpoint(() =>
      client.GET('/physician/{id}', {
        params: {
          path: {
            id,
          },
        },
      }),
    )
  },
  async checkHasPatient(id: number, patientId: number) {
    return wrapEndpoint(() =>
      client.GET('/physician/{id}/has-patient/{patientId}', {
        params: {
          path: {
            id,
            patientId,
          },
        },
      }),
    )
  },
  async list(options?: ApiSchemas['ListPhysicianDto']) {
    return wrapEndpoint(() =>
      client.GET('/physician', {
        params: {
          query: options,
        },
      }),
    )
  },
  async listAvailableFilters() {
    return wrapEndpoint(() => client.GET('/physician/available-filters'))
  },
  async addSpecialty(physicianId: number, body: ApiSchemas['CreatePhysicianSpecialtyDto']) {
    return wrapEndpoint(() =>
      client.POST('/physician/{physicianId}/specialty', {
        params: {
          path: {
            physicianId,
          },
        },
        body,
      }),
    )
  },
  async delete(id: number) {
    return wrapEndpoint(() =>
      client.DELETE('/physician/{id}', {
        params: {
          path: {
            id,
          },
        },
      }),
    )
  },
  async checkExists(data: ApiSchemas['CheckPhysicianDto']) {
    return wrapEndpoint(() =>
      client.PATCH('/physician/check', {
        body: data,
      }),
    )
  },
  async update(id: number, data: ApiSchemas['UpdatePhysicianDto']) {
    return wrapEndpoint(() =>
      client.PUT('/physician/{id}', {
        params: {
          path: {
            id,
          },
        },
        body: data,
      }),
    )
  },
  async createAsAdmin(body: ApiSchemas['CreateAdminPhysicianDto']) {
    return wrapEndpoint(() =>
      client.POST('/physician/admin', {
        body,
      }),
    )
  },
  async updateProfilePicture(id: number, body: ApiSchemas['UpdateProfilePictureDto']) {
    return wrapEndpoint(() =>
      client.PUT('/physician/{id}/profile-picture', {
        params: {
          path: {
            id,
          },
        },
        body,
        bodySerializer(body) {
          const fd = new FormData()

          fd.append('name', body.name)
          fd.append('file', body.file as unknown as Blob)

          return fd
        },
      }),
    )
  },
  async deleteProfilePicture(id: number) {
    await wrapEndpoint(() =>
      client.DELETE('/physician/{id}/profile-picture', {
        params: {
          path: {
            id,
          },
        },
      }),
    )
  },
}
